fx.service(class ThumbGenerator extends fx.Service
    {
        constructor(data)
        {
            super();

            this.model = data.creationModel;
            
            this._base64 = "";

            this._componentIndex = -1;

            this.canvas = document.createElement('canvas');
            this.context = this.canvas.getContext('2d');
            
            this.usedFontFamilies = [];
            this.fontstyle = "";

            this._generating = false;

            this.ratio = 2;
            
            this.on("font-data-uri-loaded", this._onFontDataUriLoaded, this.model.fonts);
            this.on("load-fonts-datauri-error", this._onFontDataUriLoaded, this.model.fonts);
        }
        
        get base64()
        {    
            return this._base64;
        }

        clean()
        {
            this._base64 = "";
        }


        /********* INIT AND MAIN FUNCTIONS *********/
        /* 
        Two main events are used for keeping the drawing procedure synchronous : font-data-uri-loaded when fonts dataURI loading is finished, 
        then draw-next-item each time a component finished drawing.
        Main steps :
        1 - generateThumbnail()
        2 - init() => load fonts DataURIs, then 'font-data-uri-loaded' event is triggered 
        3 - _onFontDataUriLoaded() => create font style for foreignElements, then 'draw-next-item' event is triggered
        4 - _drawNextItem() => start the drawing process, each component wait the next draw-next-item event before being drawn  */

        // starting point
        generate(creation, element, side)
        {
            try 
            {
                if (this._generating)
                    return;

                this.side = side || (creation && creation.isBook ? "right" : "left"); // for books we set side

                this.element = element ? element : creation.elements.getItemAt(0);
                this.components = this.element.components instanceof fx.ModelArray ? this.element.components.toArray() : this.element.components;

                this.creationSize = {   width : creation.pageWidth * this.ratio, 
                                        height : creation.pageHeight * this.ratio, 
                                        slice : creation.sliceWidth * this.ratio,
                                        ratio : this.ratio };

                this.canvas.width = this.creationSize.width;
                this.canvas.height = this.creationSize.height;

                // set white background
                this.context.fillStyle = "#FFF";
                this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

                this._generating = true;
                this._base64 = "";
                

                if (creation.isFrame)
                    this.components.push({component_type : "frame"});

                this._componentIndex = -1;
                this.usedFontFamilies = [];
                
                // init by loading fonts dataURI (used by ForeignObject for drawing texts)
                for(var i=0; i<this.components.length; i++)
                {
                    let component = this.components.getItemAt(i);

                    if(component.component_type == "text")
                    {
                        var htmlObject = document.createElement('div');
                        htmlObject.innerHTML = component.content;
                        let editor = new fx.components.TextEditor(htmlObject, null, this.model.fonts);
                        let fonts = editor.allFontFamilies;
                        for(var j=0; j< fonts.length; j++)
                            this.usedFontFamilies.push(this.model.fonts.find({name : fonts[j]}));
                    }
                }

                this.model.fonts.loadDataURI(this.usedFontFamilies); // after fonts are loaded, font-data-uri-loaded event is triggered

                // if not generated after 10 seconds, we stop it
                this.delay(this._stop, fx.get("settings").coverTimeOut);
            }
            catch(e)
            {
                this._stop();
                this._generating = false;
            }
        }

        _stop()
        {
            if(this._generating)
            {
                this._generating = false;
                this._componentIndex = -1;

                try
                {
                    this._base64 = this.canvas.toDataURL();

                    if (this._base64 == "data:,")
                        this._base64 = "";
                }
                catch(e)
                {
                    // TODO : manage case of tainted canvas ("Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.")
                    this._base64 = "";
                }
                this.trigger("thumb-generated", { side : this.side, element : this.element, thumb : this.base64 });
            }
        }

        // TESTING ONLY : Add canvas to DOM for testing purposes
        previewThumbnail()
        {
            var img = new Image();
            img.src = this.canvas.toDataURL();
            img.onload = this.addPreviewNodeToStage.bind(this);
        }

        addPreviewNodeToStage(event)
        {
            var img = event.target;
            img.style.position = "absolute";
            img.style.left = "0px";
            img.style.top = "0px";
            this.stage.node.appendChild(img);
        }

      
        /********* EVENTS *********/

        // When fonts dataURI are loaded, we trigger draw-next-item for starting the drawing procedure
        _onFontDataUriLoaded()
        {
            this.fontstyle = "";
            for(var i=0; i<this.usedFontFamilies.length; i++)
            {
                if(this.usedFontFamilies[i].dataURI)
                {
                    this.fontstyle += ` @font-face {
                        font-family: `+this.usedFontFamilies[i].name+`;
                        font-style: normal;
                        font-weight: normal;
                        src: url(`+this.usedFontFamilies[i].dataURI+`) format('truetype');
                    }`;
                }
            }
            this._drawNextItem();
        }
        
        // The drawing procedure begins here
        _drawNextItem()
        {
            this.delay(this._onDrawNextItem, 10);
        }

        
        _onDrawNextItem()
        {
            this.delay(this.onLoadError, null);

            if(this._componentIndex<this.components.length-1)
                this.drawComponent(++this._componentIndex);
            else
                this._stop();
        }

        /********* FUNCTIONS FOR LOADING AND DRAWING COMPONENTS ON CANVAS *********/

        // draw-next-item event is triggered after each component finished drawing, for keeping the drawing synchronous
        drawComponent(index)
        {
            let component = this.components.getItemAt(index);

            let parameters = {  element : this.element, 
                                component : component, 
                                model : this.model, 
                                context : this.context, 
                                side : this.side, 
                                creationSize : this.creationSize, 
                                fontstyle : this.fontstyle};
            
            switch(component.component_type)
            {
                case "photo":
                    this._currentElement = new shared.components.CoverThumbPhoto(parameters);
                    break;

                case "sticker":
                    this._currentElement = new shared.components.CoverThumbSticker(parameters);
                    break;        

                case "background":
                    this._currentElement = new shared.components.CoverThumbBackground(parameters);
                    break;     

                case "text":
                    this._currentElement = new shared.components.CoverThumbText(parameters);
                    break;  

                case "shape":
                    this._currentElement = new shared.components.CoverThumbShape(parameters);
                    break;     

                case "frame" : 
                    this._currentElement = new shared.components.CoverThumbFrame(parameters);
                    break;

                default: 
                    this._currentElement = null;
                    break;
            }

            if (this._currentElement)
            {
                this.on("ready", this._drawNextItem, this._currentElement);
                this._currentElement.load();
            }
            else
                this._drawNextItem();
        }
    });